import type { ReactNode } from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint';

interface BreakpointGateProps {
  select: (breakpoint: number) => boolean;
  children: ReactNode;
}

/**
 * Renders its children only while `select(breakpoint)` is true. The width check lives here rather
 * than in the parent, so crossing the breakpoint re-renders only this gate.
 */
export default function BreakpointGate({ select, children }: BreakpointGateProps) {
  return useBreakpoint(select) ? children : null;
}
